module.exports = __webpack_public_path__ + "8.dbbf7606.png";